import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/AccommodationAddHeader.Skeleton.Styles'

interface BreadcrumbsProps {}
const AccommodationAddHeaderSkeleton: React.FC<BreadcrumbsProps> = ({}) => {
  const classes = useStyles()

  return (
    <div className={classes.topBar}>
      <Typography variant="body1">
        <Skeleton animation="wave" className={classes.skeleton} />
      </Typography>
    </div>
  )
}
export default AccommodationAddHeaderSkeleton
